import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { Container, Grid } from '@mui/material'
import React from 'react'
import { Heading, P, SectionHeading, SectionSubWrapper, SectionWrapper } from '../../../Styles/style'
import clip from "../../../../assets/images/attachfile.png"
import OpenSource from '../../../Components/OpenSource'
import Availible from '../../../Components/Availible'
import S9_Footer from '../../Main/S9_Footer'
const EmailInput = styled.input`
    width: 100%;
    padding:10px;
`
const TextInput = styled.textarea`
    width: 100%;
    padding:10px;
    height: 250px;
    position: relative;
`
const AttachButt = styled.button`
  display: flex;
  padding: 5px 30px;
  align-items: center;
  font-family: "Poppins-Medium";
  font-size: 15px;
  background-color: ${(props) => props.theme.btnSecondary};
  position: absolute;
  bottom: 8px;
  right: 0;
  cursor: pointer;
  border: 1px solid  ${(props) => props.theme.textPrimary};
`
const ConnectButt = styled.button`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.btnPrimary)};
display: flex;
align-items: center;
text-align: center;
width: 100%;
place-content: center;
margin: ${(props) => (props.m ? props.m : "20px 0")};
padding: ${(props) => (props.p ? props.p : "11px 30px")};
font-family: "Poppins-Medium";
font-size: 15px;
color: ${(props) => props.theme.textPrimary};
text-decoration:none ;
cursor: pointer;
border: 1px solid ${(props) => (props.border ? props.border : props.theme.textPrimary)};
@media screen and (max-width:599px){
  /* padding: ${(props) => (props.p ? props.p : "7px 10px")}; */
  /* max-width: ${(props) => (props.mw ? props.mw : "50%")}; */

}
`
const S2_DefiEcosystem = () => {
    const theme = useTheme()
    return (
        <div>
            <SectionSubWrapper p="4rem 0" bgcolor={theme.bgQuaternary}>
                <Container maxWidth="xl">
                    <Grid container justifyContent="center">
                        <Grid xs={12} md={7}>
                            <SectionHeading align="Center" data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="300"
                                data-aos-offset="0"
                                data-aos-duration="500">Contribute In Private And Secure<br />
                                Defi Ecosystem.</SectionHeading>
                            <P align="Center" data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="400"
                                data-aos-offset="0"
                                data-aos-duration="500">It Is Open Source. You Can Always Test Its Privacy And Security And
                                <br /> Propose New Features. </P>
                            <Heading p="30px 0 10px" data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="400"
                                data-aos-offset="0"
                                data-aos-duration="500">Email</Heading>
                            <EmailInput type="email" placeholder="Enter your Email" data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="500"
                                data-aos-offset="0"
                                data-aos-duration="500"/>
                            <Heading p="30px 0 10px" data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="600"
                                data-aos-offset="0"
                                data-aos-duration="500">Subject</Heading>
                            <EmailInput type="text" placeholder="Enter your Subject" data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="600"
                                data-aos-offset="0"
                                data-aos-duration="500" />
                            <Heading p="30px 0 10px"  data-aos="fade-zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="700"
                                data-aos-offset="0"
                                data-aos-duration="500">Message</Heading>
                            <div style={{ position: "relative" }}>
                                <TextInput type="text" placeholder="Enter your Message"  data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="800"
                                data-aos-offset="0"
                                data-aos-duration="500"/>
                                <AttachButt  data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="800"
                                data-aos-offset="0"
                                data-aos-duration="500"><img src={clip} />&nbsp;Attach File</AttachButt>
                            </div>
                            <ConnectButt  data-aos="zoom-in"
                                data-aos-easing="ease-in"
                                data-aos-delay="900"
                                data-aos-offset="0"
                                data-aos-duration="500">Contribute</ConnectButt>
                        </Grid>
                    </Grid>
                </Container>
            </SectionSubWrapper>
            <OpenSource link1st="#" bgcolor1st={theme.Approvecolor} heading1st="Audit Report"
                link2nd="#" bgcolor2nd={theme.btnSecondary} heading2nd="Github"
                link3rd="#" bgcolor3rd={theme.btnPrimary} heading3rd="Documentation" />
            <Availible />
            <S9_Footer />
        </div>
    )
}

export default S2_DefiEcosystem